<template>
  <section class="contact">
    <div class="contact__layout">
      <!-- Left: Brand Message -->
      <div class="contact__info">
        <span class="section-label">Get in Touch</span>

        <h2 class="contact__title">
          향에 대한 이야기를<br>
          <em>들려주세요</em>
        </h2>

        <div class="divider" />

        <p class="contact__desc">
          원하는 향이 있거나, 사용하면서 느낀 점, 아쉬운 점,
          혹은 새롭게 바라는 제품 아이디어가 있다면 편하게 이야기해 주세요.
        </p>

        <p class="contact__desc">
          Perfume Wiz는 고객과의 소통을 통해
          더 좋은 향과 더 나은 제품으로 발전해갑니다.
        </p>

        <div class="contact__details">
          <div class="contact__detail">
            <span class="contact__detail-label">Kakao</span>
            <a
                :href="kakaoChannelUrl"
                target="_blank"
                rel="noopener"
                class="contact__detail-value"
            >
              카카오톡 채널 바로가기
            </a>
          </div>

          <div class="contact__detail">
            <span class="contact__detail-label">Instagram</span>
            <a
                href="https://instagram.com/perfume_wiz"
                target="_blank"
                rel="noopener"
                class="contact__detail-value"
            >
              @perfume_wiz
            </a>
          </div>

          <div class="contact__detail">
            <span class="contact__detail-label">Email</span>
            <a href="mailto:hello@perfumewiz.com" class="contact__detail-value">
              hello@perfumewiz.com
            </a>
          </div>
        </div>

        <div class="contact__social">
          <a
              v-for="social in socials"
              :key="social.name"
              :href="social.url"
              target="_blank"
              rel="noopener"
              class="contact__social-link"
          >
            {{ social.name }}
          </a>
        </div>
      </div>

      <!-- Right: Kakao CTA Card -->
      <div class="contact__cta-wrap">
        <div class="contact__cta-card">
          <span class="contact__cta-label">Talk with Perfume Wiz</span>

          <h3 class="contact__cta-title">
            카카오톡으로<br>
            편하게 문의하세요
          </h3>

          <p class="contact__cta-desc">
            제품 문의부터 원하는 향 제안, 사용 후 피드백까지 자유롭게 메시지 남겨주세요.
          </p>

          <div class="contact__cta-list-wrap">
            <p class="contact__cta-list-title">이런 이야기를 기다리고 있어요</p>
            <ul class="contact__cta-list">
              <li class="contact__cta-item">제품 문의</li>
              <li class="contact__cta-item">원하는 향 제안</li>
              <li class="contact__cta-item">협업 및 제휴 문의</li>
              <li class="contact__cta-item">사용 후기 및 개선 의견</li>
            </ul>
          </div>

          <div class="contact__cta-note">
            <p>가볍게 남겨주셔도 괜찮습니다.</p>
            <p>Perfume Wiz는 고객의 한마디를 소중하게 생각합니다.</p>
          </div>

          <button class="contact__cta-button" @click="openKakao">
            카카오톡 채널로 이야기하기
          </button>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="contact__footer">
      <p class="contact__copyright">
        © {{ currentYear }} Perfume Wiz. All rights reserved.
      </p>
      <p class="contact__credit">
        Made for spaces that deserve a better scent.
      </p>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'ContactSection',
    data() {
      return {
        kakaoChannelUrl: 'https://pf.kakao.com/_xkxkFZX/chat',
        socials: [
          { name: 'Kakao', url: 'https://pf.kakao.com/_xkxkFZX/chat' },
          { name: 'Instagram', url: 'https://instagram.com/perfume_wiz' },
//          { name: 'Naver Blog', url: 'https://blog.naver.com/perfume_wiz' },
//          { name: 'Email', url: 'mailto:hello@perfumewiz.com' }
        ]
      }
    },
    computed: {
      currentYear() {
        return new Date().getFullYear()
      }
    },
    methods: {
      openKakao() {
        window.open(this.kakaoChannelUrl, '_blank')
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/styles/variables';

  .contact {
    background-color: $color-ivory-dark;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: hidden;
    @media (max-width: $bp-tablet) {
      height: auto !important;
    }
  }

  .contact__layout {
    display: grid;
    grid-template-columns: 0.95fr 1.05fr;
    flex: 1;
    min-height: 0;

    @media (max-width: $bp-tablet) {
      grid-template-columns: 1fr;
    }
  }

  .contact__info {
    background-color: $color-forest;
    padding: 80px 64px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @media (max-width: $bp-tablet) {
      padding: 64px 48px;
    }

    @media (max-width: $bp-mobile) {
      padding: 72px 24px 36px;
    }
  }

  .contact__title {
    font-family: $font-heading;
    font-size: clamp(36px, 3.2vw, 52px);
    font-weight: 400;
    color: $color-ivory;
    line-height: 1.15;
    margin-bottom: 8px;

    em {
      display: inline-block;
      font-style: italic;
      color: $color-gold-light;
    }

    @media (max-width: $bp-mobile) {
      font-size: 32px;
    }
  }

  .contact__desc {
    font-family: $font-body;
    font-size: 14px;
    font-weight: 300;
    color: rgba($color-ivory, 0.72);
    line-height: 1.9;
    max-width: 430px;
    margin-bottom: 18px;

    @media (max-width: $bp-mobile) {
      font-size: 13px;
      line-height: 1.7;
      margin-bottom: 12px;
    }
  }

  .contact__details {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 12px;
    margin-bottom: 36px;

    @media (max-width: $bp-mobile) {
      gap: 10px;
      margin-bottom: 20px;
    }
  }

  .contact__detail {
    display: flex;
    gap: 20px;
    align-items: baseline;

    @media (max-width: $bp-mobile) {
      flex-direction: row;
      gap: 12px;
    }
  }

  .contact__detail-label {
    font-family: $font-body;
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: $color-gold;
    min-width: 72px;
  }

  .contact__detail-value {
    font-family: $font-body;
    font-size: 14px;
    font-weight: 300;
    color: rgba($color-ivory, 0.88);
    transition: color $transition-base;

    &:hover {
      color: $color-gold-light;
    }
  }

  .contact__social {
    display: flex;
    flex-wrap: wrap;
    gap: 18px;
  }

  .contact__social-link {
    font-family: $font-body;
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: rgba($color-ivory, 0.5);
    transition: color $transition-base, border-color $transition-base;
    border-bottom: 1px solid transparent;
    padding-bottom: 2px;

    &:hover {
      color: $color-gold;
      border-bottom-color: $color-gold;
    }
  }

  .contact__cta-wrap {
    background-color: $color-ivory;
    padding: 80px 64px;
    display: flex;
    align-items: center;
    justify-content: center;

    @media (max-width: $bp-tablet) {
      padding: 64px 48px;
    }

    @media (max-width: $bp-mobile) {
      padding: 32px 24px 48px;
    }
  }

  .contact__cta-card {
    width: 100%;
    max-width: 640px;
    background: rgba($color-white, 0.35);
    border: 1px solid rgba($color-forest, 0.08);
    padding: 48px 44px;
    box-shadow: 0 24px 60px rgba($color-forest, 0.06);

    @media (max-width: $bp-mobile) {
      padding: 32px 24px;
    }
  }

  .contact__cta-label {
    display: inline-block;
    font-family: $font-body;
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: rgba($color-forest, 0.45);
    margin-bottom: 16px;
  }

  .contact__cta-title {
    font-family: $font-heading;
    font-size: clamp(28px, 2.8vw, 42px);
    font-weight: 400;
    line-height: 1.2;
    color: $color-forest;
    margin-bottom: 16px;

    @media (max-width: $bp-mobile) {
      font-size: 26px;
      margin-bottom: 10px;
    }
  }

  .contact__cta-desc {
    font-family: $font-body;
    font-size: 15px;
    font-weight: 300;
    line-height: 1.9;
    color: rgba($color-forest, 0.72);
    margin-bottom: 28px;

    @media (max-width: $bp-mobile) {
      font-size: 13px;
      line-height: 1.7;
      margin-bottom: 16px;
    }
  }

  .contact__cta-list-wrap {
    border-top: 1px solid rgba($color-forest, 0.1);
    border-bottom: 1px solid rgba($color-forest, 0.1);
    padding: 24px 0;
    margin-bottom: 24px;
  }

  .contact__cta-list-title {
    font-family: $font-body;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: $color-gold-dark;
    margin-bottom: 16px;
  }

  .contact__cta-list {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px 20px;

    @media (max-width: $bp-mobile) {
      grid-template-columns: 1fr;
    }
  }

  .contact__cta-item {
    position: relative;
    padding-left: 16px;
    font-family: $font-body;
    font-size: 14px;
    font-weight: 300;
    line-height: 1.7;
    color: rgba($color-forest, 0.82);

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 10px;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: $color-gold;
    }
  }

  .contact__cta-note {
    margin-bottom: 28px;

    p {
      font-family: $font-body;
      font-size: 13px;
      font-weight: 300;
      line-height: 1.8;
      color: rgba($color-forest, 0.55);
    }
  }

  .contact__cta-button {
    width: 100%;
    padding: 18px 20px;
    background-color: $color-forest;
    color: $color-ivory;
    border: none;
    font-family: $font-body;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    cursor: pointer;
    transition: background-color $transition-base, transform $transition-base;

    &:hover {
      background-color: $color-gold-dark;
      transform: translateY(-1px);
    }
  }

  .contact__footer {
    padding: 20px 64px;
    background-color: $color-forest;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (max-width: $bp-mobile) {
      padding: 16px 24px;
      /*padding-bottom: calc(16px + env(safe-area-inset-bottom, 16px));*/
      padding-bottom: 100px;
      flex-direction: column;
      gap: 6px;
      text-align: center;
    }
  }

  .contact__copyright {
    font-family: $font-body;
    font-size: 11px;
    color: rgba($color-ivory, 0.4);
    letter-spacing: 0.06em;
  }

  .contact__credit {
    font-family: $font-heading;
    font-size: 13px;
    font-style: italic;
    color: rgba($color-ivory, 0.3);
  }
</style>